import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "currentColor",
  viewBox: "0 0 280.067 280.067"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M149.823 257.142c-31.398 30.698-81.882 30.576-113.105-.429-31.214-30.987-31.337-81.129-.42-112.308l-.026-.018L149.841 31.615l14.203-14.098c23.522-23.356 61.65-23.356 85.172 0s23.522 61.221 0 84.586l-125.19 123.02-.044-.035c-15.428 14.771-40.018 14.666-55.262-.394-15.244-15.069-15.34-39.361-.394-54.588l-.044-.053 13.94-13.756 69.701-68.843 13.931 13.774-83.632 82.599c-7.701 7.596-7.701 19.926 0 27.53s20.188 7.604 27.88 0L235.02 87.987l-.035-.026.473-.403c15.682-15.568 15.682-40.823 0-56.39s-41.094-15.568-56.776 0l-.42.473-.026-.018-14.194 14.089L50.466 158.485c-23.522 23.356-23.522 61.221 0 84.577s61.659 23.356 85.163 0l99.375-98.675 14.194-14.089 14.194 14.089-14.194 14.098-99.357 98.675z" }, null, -1)
  ])))
}
export default { render: render }